import React from 'react'
import { useSelector } from "react-redux";
import assetify from "@quintype/framework/assetify";
import get from "lodash/get";
import { SUBSCRIPTION_PAGE_URL } from "../../../constants";
import subscriptionImage from "../../../../assets/images/nl-images/subscription-CTA.png";

import LoadingIcon from "../../../../assets/images/loader.svg";
import { Button } from "../../atoms/button";
import { Link } from "@quintype/components";
import './podcast-letters.m.css'
import { Modal } from '../../molecules/modal';
export function PodcastLetters() {

    const hasSubscription = useSelector(state => {
        return get(state, ["isSubscribedUser", "userHasSubscription"], null);
    });
    const member = useSelector(state => {
      return get(state, ["member"], null);
  });


    return (
          <React.Fragment>
           {(member && hasSubscription === null ) && <div styleName="modal">
              <div styleName="modal-content">
                <img src={assetify(LoadingIcon)} alt="loading" />
              </div>
            </div>}

            <div style={!hasSubscription? {opacity:"0.2"}:{opacity:"1"} } styleName="form">
              <br/>
              <iframe styleName="iframe" src="https://docs.google.com/forms/d/e/1FAIpQLSc7GPSlA7dG7HVufK8YRUEF9nLXIA29eTujks7AidRSfCFh7w/viewform?embedded=true" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>

            {!hasSubscription &&  
              <Modal hideCloseIcon>
                <div styleName="wrapper">
    
                  <div styleName="content-wrapper">
                    <h4 styleName="headline">Oops! This content is only available to subscribed users </h4>
                    <div styleName="content">
                      Pay to keep news free. Complaining about the media is easy and often justified. But hey, it’s the model that’s flawed.
                    </div>
                    <div style={{marginRight:"20px"}} styleName="button">
                      <Button className="nl-btn-large" href={SUBSCRIPTION_PAGE_URL + `?podcast-letters`}>
                        Subscribe
                      </Button>
                    </div>
                    <div styleName="button">
                      <Link style={{marginRight:"20px"}} href={`/`}>
                        Home
                      </Link>
                    </div>
                  </div>

                  <div styleName="image-wrapper">
                    
                    <img styleName="image" src={assetify(subscriptionImage)} alt="newslaundry logo" />
                  </div>

              </div>
            </Modal>
          }
        </React.Fragment>
    )


  }

